import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { TextField, Box } from '@mui/material';
import "./_.scss";

const YearPicker = ({ value, handleChange, name }) => {
  return (
    <Box sx={{ width: "100%" }}>
        <LocalizationProvider dateAdapter={AdapterDateFns} style={{width:'100%'}}>
            <DatePicker
                views={['year']}
                value={value}
                style={{width:'100%'}}
                onChange={(newValue) =>
                    handleChange({
                        target: { name, value: newValue },
                    })
                }
                slotProps={{
                    popper: {
                        className: "date-picker-vf1__popper full-width",
                    },
                }}
                renderInput={(params) => <TextField {...params} fullWidth variant="outlined" />}
            />
        </LocalizationProvider>
    </Box>
  );
};

export default YearPicker;